import { AxiosError } from 'axios';
import { ALPN_ENABLED } from 'constants';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import {
  loadTemplateFolders,
  loadTemplates,
} from '~src/services/api/templates';
import { DbFolder, DbFolderProperties, DbProject } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useProject } from './useProject';

interface UseTemplatesParams {
  skip?: number;
  take?: number;
}

export const useTemplates = (
  { skip, take }: UseTemplatesParams = {},
  queryConfig: QueryConfig<DbProject[], AxiosError> & { enabled?: boolean } = {}
) => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const templatesQuery = useQuery<DbProject[], AxiosError>(
    ['templates', { projectId: projectId, skip, take }],
    loadTemplates,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return templatesQuery;
};

interface UseTemplateFoldersParams {
  templateId: string;
  showDeleted?: boolean;
  skip?: number;
  take?: number;
}

export const useTemplateFolders = (
  { templateId, showDeleted, skip, take }: UseTemplateFoldersParams,
  queryConfig: QueryConfig<DbFolder[], AxiosError> & { enabled?: boolean } = {}
) => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const templateFoldersQuery = useQuery<DbFolder[], AxiosError>(
    [
      'templateFolders',
      {
        projectId: projectId,
        templateId: templateId,
        showDeleted: showDeleted,
        skip: skip,
        take: take,
      },
    ],
    loadTemplateFolders,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return templateFoldersQuery;
};
